import Nullstack from 'nullstack';
export default function IconCalendarTime({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-calendar-time",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "18",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M15 3v4"
  }), "   ", Nullstack.element("path", {
    d: "M7 3v4"
  }), "   ", Nullstack.element("path", {
    d: "M3 11h16"
  }), "   ", Nullstack.element("path", {
    d: "M18 16.496v1.504l1 1"
  }), " ");
}